import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance';
import { BaseError } from '@utils/types/shared/base';
import { AdminPlanResponse, AdminPlanPayload } from '@utils/types/admin';
import { ADMIN_PLANS_QUERY_KEY } from './use-get-admin-plans';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

/**
 * Hook to create a new plan
 *
 * POST /api/admin/on-prem/plans
 */
export const useCreateAdminPlan = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const createPlan = async (payload: AdminPlanPayload) => {
    const url = `api/admin/on-prem/plans`;
    const response = await Axios.post<AdminPlanResponse>(url, payload);
    return response.data;
  };

  return useMutation<
    AdminPlanResponse,
    AxiosError<BaseError>,
    AdminPlanPayload
  >(createPlan, {
    onSuccess: () => {
      toast.success(t('plan-created-successfully'));
      queryClient.invalidateQueries([ADMIN_PLANS_QUERY_KEY]);
    },
    onError: (error: AxiosError<BaseError>) => {
      const errorMessage =
        error.response?.data?.error_description ||
        error.response?.data?.detail ||
        error.response?.data?.error ||
        error.response?.data?.message ||
        t('failed-to-create-plan');
      toast.error(errorMessage);
    }
  });
};
